import { Injectable } from '@angular/core';
import dsBridge from 'dsbridge';
type FlutterRoute<T> = {
  params?: T;
  routeName: string;
};
@Injectable({
  providedIn: 'root',
})
export class BridgeService {
  getSysInfo(key: string) {
    const sysInfo = dsBridge.call('getSysInfo', key);
    return sysInfo;
  }
  goToDetail<T>(route: FlutterRoute<T>) {
    dsBridge.call('goToRoutes', route);
  }
  getPlatform(): "android" | "flutter" | "H5" {
    const platform = dsBridge.call('getPlatform');
    return platform ?? "H5";
  }
}
